"use client";

import { DesignSystemProvider } from "@zapier/design-system";
import { useRouter } from "next/navigation";
import type { ReactNode } from "react";

export const DesignSystemRoutingProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const router = useRouter();
  return (
    <DesignSystemProvider navigate={router.push}>
      {children}
    </DesignSystemProvider>
  );
};
